module.exports = __webpack_public_path__ + "media/img/pay-3-4ee6326397faa20c5d6b339403f2665e.svg";